import FileRequestModal from "@/containers/Parlor/ParlorDetailContainer/components/Modal/FileRequestModal";
import { Box, Flex } from "@chakra-ui/react";
import { useOverlay } from "@toss/use-overlay";
import { colors, customEvent, EventPathType, getCdnImageSrc, HStack, Image } from "goi_common";
import type { ComponentType } from "react";

// 자료 받아보기 클릭 시 띄울 모달의 인터페이스. 기본은 FileRequestModal.
// 실험 등으로 모달을 wrapper로 감싸야 할 때 ModalComponent prop으로 주입.
type FileRequestModalLikeProps = {
  isOpen: boolean;
  onClose: () => void;
  path: keyof typeof EventPathType;
};

export default function FullscreenDrawerContent({
  onClose,
  onSuccess,
  path = "login",
  eventPath = "gnb",
  ModalComponent = FileRequestModal,
}: {
  onClose: any;
  onSuccess: any;
  path?: keyof typeof EventPathType;
  eventPath?: keyof typeof EventPathType;
  ModalComponent?: ComponentType<FileRequestModalLikeProps>;
}) {
  const backgroundImage =
    path === "match_req_leave" || path === "parlor_req_quit"
      ? getCdnImageSrc("platform/login/request-background2.png")
      : getCdnImageSrc("platform/login/request-background.png");
  const overlay = useOverlay();

  const requestEstimate = () => {
    customEvent({
      newGtm: {
        path: eventPath,
        trigger_and_target: "open_file_request_modal",
      },
    });

    overlay.open(({ isOpen, close: onFileRequestClose }) => {
      return (
        <ModalComponent
          path={path}
          isOpen={isOpen}
          onClose={() => {
            onFileRequestClose();
            onSuccess();
          }}
        />
      );
    });
  };

  return (
    <Box
      gap={1}
      width="100%"
      height="100%"
      backgroundColor={colors.gray900}
      borderRadius="10px"
      position="relative"
      overflow="hidden"
    >
      <Image src={backgroundImage} alt="" />
      <HStack
        position="absolute"
        style={{
          bottom: 0,
          zIndex: 2,
        }}
        borderRadius="10px"
        width="100%"
        height="60px"
      >
        <Flex
          onClick={onClose}
          borderRadius="0 0 0 10px"
          width="30%"
          className="button_16_sb"
          backgroundColor={colors.black}
          color={colors.white}
          alignItems="center"
          justifyContent="center"
        >
          닫기
        </Flex>
        <Flex
          onClick={requestEstimate}
          borderRadius="0 0 10px 0"
          width="70%"
          className="button_16_sb"
          backgroundColor={colors.orange650}
          color={colors.white}
          alignItems="center"
          justifyContent="center"
        >
          자료 받아보기
        </Flex>
      </HStack>
    </Box>
  );
}
